module.exports = "/images/hslp-tier-2.png?c5d9a536a0fe14a202780cfbd626051c";